import { AgentsApi } from '@quadminds/client-apis/agents';
import { isStorkPlatform } from '../utils/utils';

// Get the agents API URL from environment variables
const AGENTS_API_URL = process.env['NX_AGENTS_API_URL'];

if (!AGENTS_API_URL) {
    throw new Error('NX_AGENTS_API_URL environment variable is required but not set');
}

// Create the agents API instance with the configured URL
export const agentsApi = new AgentsApi({
    baseURL: AGENTS_API_URL,
    withCredentials: true,
    debug: true,
    useUnauthorizedInterceptor: false, // We'll handle auth in the app's own interceptors
});

agentsApi.httpClient.interceptors.request.use((config) => {
    if (isStorkPlatform()) {
        config.headers['X-Auth-Provider'] = 'stork';
    }
    return config;
});
